<template>
<div>
  <span>
    <button
      class="button is-ghost"
      @click="isImagesModalActive = true"
    >
      <span class="icon">
        <i class="fas fa-images"></i>
      </span>
      <span>{{ images.length }}</span>
    </button>
  </span>
  <b-modal
    v-model="isImagesModalActive"
    :destroy-on-hide="false"
    aria-role="dialog"
    close-button-aria-label="Close"
    aria-modal
  >
    <template #default="props">
      <ul>
        <li v-for="image in images" class="mb-5">
          <div class="card">
            <div class="card-image">
              <fb-img
                :fileId="image.fileId"
                :mimeType="image.mimeType"
                size="raw"
              />
            </div>
            <div
              v-if="image.caption"
              class="card-content"
            >
              <div class="media">
                <div class="media-content">{{ image.caption }}</div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </template>
  </b-modal>
</div>
</template>
<script>
import FbImg from '@/components/atoms/FbImg'

export default{
  name: 'ImageModals',

  props: {
    images: {
      type: Array,
      required: true,
      default: [],
    },
  },

  components: {
    FbImg,
  },

  data(){
    return {
      isImagesModalActive: false,
    }
  },

  computed: {
  },

  async created() {
  },

  methods: {
  },
}
</script>


